import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
/**
 *
 * @param data Object
 * @param organisation OrganisationModel
 * @param serviceEntry ServiceEntryModel
 * @return {Promise<any>|Promise}
 */
export default (function (data, organisation, serviceEntry) {
    var url = applyPathVariables(EndPoints.SERVICE_ENTRY_CLOSE_RETROACTIVELY, {
        organisationId: organisation.id,
        serviceEntryId: serviceEntry.serviceEntryId
    });
    var request = new Request({ method: Methods.POST, url: url, withCredentials: true, data: data });
    return request.execute();
});
